import { lazy } from 'react';
import { Route } from 'react-router-dom';
import AppRoute from '../utility/AppRoute';
import ProtectedRoute from '../shared/ProtectedRoute/ProtectedRoute';
import { Roles } from './roles';

const HrDepartments = lazy(() => import('../modules/Admin/components/Hr/HrDepartments'));
const HrDesignations = lazy(() => import('../modules/Admin/components/Hr/HrDesignations'));
const HrEmployees = lazy(() => import('../modules/Admin/components/Hr/HrEmployees'));
const HrHolidays = lazy(() => import('../modules/Admin/components/Hr/HrHolidays'));
const HrLeaveBalances = lazy(() => import('../modules/Admin/components/Hr/HrLeaveBalances'));

const allStaff = [Roles.SuperAdmin, Roles.Admin, Roles.Manager, Roles.Employee];

export const hrRoutes = (
  <>
    <Route path="/hr/departments" element={<ProtectedRoute allowedRoles={allStaff}><AppRoute><HrDepartments /></AppRoute></ProtectedRoute>} />
    <Route path="/hr/designations" element={<ProtectedRoute allowedRoles={allStaff}><AppRoute><HrDesignations /></AppRoute></ProtectedRoute>} />
    <Route path="/hr/employees" element={<ProtectedRoute allowedRoles={allStaff}><AppRoute><HrEmployees /></AppRoute></ProtectedRoute>} />
    <Route path="/hr/holidays" element={<ProtectedRoute allowedRoles={allStaff}><AppRoute><HrHolidays /></AppRoute></ProtectedRoute>} />
    <Route path="/hr/leave" element={<ProtectedRoute allowedRoles={allStaff}><AppRoute><HrLeaveBalances /></AppRoute></ProtectedRoute>} />
  </>
);
